import { render, staticRenderFns } from "./LichSuDichVuDiemDenList.vue?vue&type=template&id=3281ad46"
import script from "./LichSuDichVuDiemDenList.vue?vue&type=script&lang=js"
export * from "./LichSuDichVuDiemDenList.vue?vue&type=script&lang=js"
import style0 from "./LichSuDichVuDiemDenList.vue?vue&type=style&index=0&id=3281ad46&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports